<template>
  <a
    href="#"
    class="icon icon-back text-dark-100 hover:text-dark-100"
    data-test-id="btn_back"
    @click.prevent="emit('click')"
  >
    <i class="icon icon-arrow_left"></i>
  </a>
</template>

<script lang="ts" setup>
const emit = defineEmits<{
  (e: 'click'): void;
}>();
</script>
